/**
 * Service for disabling buttons that render or call
 * certain actions based on a users role or permissions
 */
export default function roleDisabled(userRoles, roles) {
  return userRoles && !roles.some((val) => userRoles.includes(val));
}
